import { z } from "zod";

const translationPath =
  "chatBot.page.service.memberAvailabilityPauseReason.errors.";

export const memberAvailabilityPauseReasonSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, translationPath + "name"),
});

export type TMemberAvailabilityPauseReasonForm = z.infer<
  typeof memberAvailabilityPauseReasonSchema
>;
